type Props = {
    terms: string;
};

export const TermsBox = ({ terms }: Props) => <div className="scrollbar-hide r-h-[120px] r-overflow-scroll r-bg-gray-100 r-p-3">{terms}</div>;
